import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import language files
import enTranslation from './locales/en.json';
import zhTranslation from './locales/zh.json';

// Configure i18next
i18n
  .use(LanguageDetector) // Automatically detect language
  .use(initReactI18next) // Initialize react-i18next
  .init({
    resources: {
      en: {
        translation: enTranslation
      },
      zh: {
        translation: zhTranslation
      }
    },
    fallbackLng: 'en', // Default language
    debug: false, // Disable debug mode to hide missing key warnings
    interpolation: {
      escapeValue: false // React already escapes strings
    },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'language',
      caches: ['localStorage']
    }
  });

export default i18n;
